<template>
  <b-card no-body>
    <b-card-body>
      <vue-apex-charts type="line" height="350" :options="chartOptions" :series="series" />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardHeader,
  BCardTitle,
  BCardSubTitle,
  BBadge,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import adequacaoChartData from "./adequacaoChartData";
import moment from "moment-timezone";
export default {
  components: {
    VueApexCharts,
    BCardHeader,
    BCard,
    BBadge,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
  },
  data() {
    return {
      adequacaoChartData,
      series: [],
      chartOptions: {
        chart: {
          zoom: {
            enabled: true,
            type: "x",
            resetIcon: {
              offsetX: -10,
              offsetY: 0,
              fillColor: "#fff",
              strokeColor: "#37474F",
            },
            selection: {
              background: "#90CAF9",
              border: "#0D47A1",
            },
          },
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true | '<img src="/static/icons/reset.png" width="20">',
              customIcons: []
            },
            export: {
              csv: {
                filename: "",
                columnDelimiter: ',',
                headerCategory: 'category',
                headerValue: 'value',
                dateFormatter(timestamp) {
                  return new Date(timestamp).toDateString()
                }
              },
              svg: {
                filename: "",
              },
              png: {
                filename: "",
              }
            },
            autoSelected: 'zoom' 
      },
        },
        legend: {
          show: true,
          position: "top",
          horizontalAlign: "left",
        },
        // markers: {
        //   strokeWidth: 1,
        //   strokeOpacity: 1,
        //   strokeColors: '#2f79bb',
        //   colors: '#2f79bb',
        // },
        colors: ["#2f79bb", "transparent"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        grid: {
          xaxis: {
            position: "top",
            categories: ["1º", "2º", "3º", "4º", "5º"],
            offsetY: 10,
            labels: {
              style: {
                colors: "#5b5b5b",
                fontSize: "0.86rem",
                fontFamily: "Helvetica, Arial, sans-serif",
                fontWeight: "600",
              },
            },
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
          },
        },
        tooltip: {
          enabled: true,
          x: {
            show: true,
            format: "dd MMM HH:mm",
            position: "top",
            offsetY: -5,
            itemMargin: {
              horizontal: 5,
              vertical: 10,
            },
          },
          dataLabels: {
            enabled: false,
          },
          colors: ["#405082", "#2f79bb"],
          plotOptions: {
            bar: {
              columnWidth: "20px;",
            },
            distributed: true,
          },
          yaxis: {
            labels: {
              show: false,
              style: {
                colors: "#5b5b5b",
                fontSize: "0.86rem",
              },
            },
          },
        },
        xaxis: {
          categories: [],
          type: "datetime",
          labels: {
            format: "HH:mm",
            datetimeUTC: false,
          },
        },
        yaxis: {
          labels: {
            formatter: function (val, index) {
              return val.toFixed(0) + "ºC";
            },
          },
        },
        noData: {
          text: "No Data",
        },
      },
    };
  },
  computed: {
    timeInterval() {
      return this.$store.state.devices.timeInterval;
    },
    deviceTZ() {
      return this.$store.state.devices.currentDevice.timezone
        ? this.$store.state.devices.currentDevice.timezone
        : "Europe/Lisbon";
    },
    fileName(){
      let currentDevice = this.$store.state.devices.currentDevice
      let file_name = `INTERNAL_TEMPERATURE_${currentDevice.model_code}-${currentDevice.name ? currentDevice.name : currentDevice.mac_number }`
      let options = { ...this.chartOptions };
      options.chart.toolbar.export.csv.filename = file_name
      options.chart.toolbar.export.svg.filename = file_name
      options.chart.toolbar.export.png.filename = file_name
      this.chartOptions = options;
    }
  },
  watch: {
    timeInterval(newProp, oldProp) {
      this.getData();
    },
    fileName(){}
  },
  methods: {
    getData() {
      this.$store.commit("devices/SET_LOADING_STATE_START_GRAPH",'loading_adeq_top');
      let deviceId = this.$route.params.id;
      let metricsEndpoint = ''
      const labelFormat = this.timeInterval > 24 ? 'dd/MM' : 'HH:mm';

      if (this.timeInterval > 2) {
        metricsEndpoint = `${process.env.VUE_APP_API_URL}api/metrics/time-series/get-data-and-label/?device=${deviceId}&interval=${this.timeInterval}&metric_field=internal_temperature&window=15`;
      }
      else {
        metricsEndpoint = `${process.env.VUE_APP_API_URL}api/metrics/time-series/get-data-and-label/?device=${deviceId}&interval=${this.timeInterval}&metric_field=internal_temperature`;
      }
      this.$http.get(metricsEndpoint).then((res) => {
        let options = { ...this.chartOptions };
        let timestampCategories = res.data.categories.map((cat) => {
          return moment(new Date(cat)).tz(this.deviceTZ).format();
        });
        options.xaxis.categories = timestampCategories;
        options.xaxis.labels.format = labelFormat;

        this.chartOptions = options;
        this.$store.commit("devices/SET_LOADING_STATE_DONE_GRAPH",'loading_adeq_top');
        this.series = [
          {
            name: this.$t("Internal Temperature"),
            data: res.data.data.map((el) => {
              return Number(el.toFixed(2));
            }),
          },
        ];
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>